import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

export class QuestTopic extends Model({
  id: types.identifierNumber,
  name: types.string,

  isSelected: false,
}) {
  toggleSelect() {
    this.isSelected = !this.isSelected;
  }
}

export const QuestTopicModel = model(QuestTopic);
